import { render, staticRenderFns } from "./antiIndulgedPay.vue?vue&type=template&id=2739aeec&scoped=true"
import script from "./antiIndulgedPay.vue?vue&type=script&lang=js"
export * from "./antiIndulgedPay.vue?vue&type=script&lang=js"
import style0 from "./antiIndulgedPay.vue?vue&type=style&index=0&id=2739aeec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2739aeec",
  null
  
)

export default component.exports